import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';
import { StorageKeys } from '../../app/share/enums/storage.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  // Create a BehaviorSubject to track enrollment type changes
  private enrollmentTypeSubject = new BehaviorSubject<string | null>(null);
  enrollmentType$ = this.enrollmentTypeSubject.asObservable();

  constructor() {
    // Initialize the BehaviorSubject with the current enrollment type from local storage
    const storedEnrollment = this.getDataFromLocalStorage(StorageKeys.enrollmentType);
    this.enrollmentTypeSubject.next(storedEnrollment);
  }

  setDataToLocalStorage(name: string, value: any) {
    // Return if name or value is not provided
    if (!name || value == null) {
      return;
    }
    try {
      let encryptedValue = '';
      // If the value is a string, encrypt it directly; otherwise, stringify then encrypt
      if (value && typeof value === 'string') {
        encryptedValue = this.encrypt(value);
      } else {
        encryptedValue = this.encrypt(JSON.stringify(value));
      }
      localStorage.setItem(name, encryptedValue);
      
      // If the enrollment type is updated, update the BehaviorSubject
      if (name === StorageKeys.enrollmentType) {
        const decrypted = this.decrypt(encryptedValue);
        let parsed;
        try {
          parsed = JSON.parse(decrypted);
        } catch (e) {
          parsed = decrypted;
        }
        this.enrollmentTypeSubject.next(parsed);
      }
    } catch (err) {
      console.info('May be issue with local storage');
    }
  }

  getDataFromLocalStorage(item: any): any {
    if (!item || typeof item !== 'string') {
      return;
    }
    const localData = localStorage.getItem(String(item));
    if (!localData) {
      return;
    }
    try {
      return JSON.parse(this.decrypt(localData));
    } catch (e) {
      return this.decrypt(localData);
    }
  }

  removeDataFromLocalStorage(item: any) {
    if (!item || typeof item !== 'string') {
      return;
    }
    localStorage.removeItem(String(item));
    // If the enrollment type is removed, update the BehaviorSubject
    if (item === StorageKeys.enrollmentType) {
      this.enrollmentTypeSubject.next(null);
    }
  }

  encrypt(value: any) {
    return CryptoJS.AES.encrypt(value, environment.PRIVATE_KEY).toString();
  }

  decrypt(value: any) {
    try {
      return CryptoJS.AES.decrypt(value, environment.PRIVATE_KEY).toString(CryptoJS.enc.Utf8);
    } catch (ex) {
      return '';
    }
  }

  clearLocalStorage() {
    localStorage.clear();
    this.enrollmentTypeSubject.next(null);
  }
}
